module.exports = __webpack_public_path__ + "img/step11.865b095b.png";